import { render, staticRenderFns } from "./Footer2.vue?vue&type=template&id=74411e55&scoped=true&"
import script from "./Footer2.vue?vue&type=script&lang=js&"
export * from "./Footer2.vue?vue&type=script&lang=js&"
import style0 from "./Footer2.vue?vue&type=style&index=0&id=74411e55&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74411e55",
  null
  
)

export default component.exports